import {
    standardActionErrorMsg, standardActionSuccessMsg, StandardActionToastMessages
} from '~commonInfra/contentActions/ActionHelpers';
import { IErrorDetail } from '~commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '~commonInfra/contentActions/MultipleItemResult';
import { L10n } from '~commonInfra/L10n/L10n';
import { Set } from '~commonInfra/utils/Set';
import { Formatters, Messages } from '~src/codegen/Localize';
import { ViewContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ContentUrlForItem } from '~src/spacesPlatform/services/ContentUrl';
import { ChangeTagsActionHelperService } from '~src/tags/ChangeTagsActionHelper';
import { IChangeContentTagsResult } from '~src/tags/IChangeContentTagsAction';
import { IViewBase } from '~src/views/models/IViewInfo';
import { Views } from '~src/views/resources/Views';

export namespace ChangeViewsTagsAction {

  export const notificationTranslationFns: StandardActionToastMessages = {
    success: standardActionSuccessMsg(Messages.changeTagsViewsSuccess),
    error: standardActionErrorMsg(Messages.changeTagsViewsError),
  };

  export function execute(itemSet: Set<IViewBase>): Promise<IChangeContentTagsResult> {
    return ChangeTagsActionHelperService.createExecuteFn<IViewBase>({
      changeTagsAction: (ids: string[], addTags: string[], removeTags: string[]) => Views.changeTags(ids, addTags, removeTags),
      getDescription: (views: Set<IViewBase>) => getDescription(views),
      notificationFns: notificationTranslationFns,
      errorDetailFn: (errorItem: IErrorItem<IViewBase>) => changeTagsErrorDetail(errorItem)
    })(itemSet);
  }

  function getDescription(views: Set<IViewBase>) {
    return (views.size() === 1)
      ? Messages.changeTagsViewDescription({ NAME: L10n.elideIfLong(views.first().name) })
      : Messages.changeTagsViewsDescription({ COUNT_LOC: Formatters.formatCount(views.size()) });
  }

  export function changeTagsErrorDetail(errorItem: IErrorItem<IViewBase>): IErrorDetail {
    return {
      itemName: errorItem.item.name,
      itemUrl: ContentUrlForItem(errorItem.item, ViewContentType),
      errorMessage: ChangeTagsActionHelperService.errorMessageFor(errorItem)
    };
  }

}

export type ChangeViewsTagsAction = typeof ChangeViewsTagsAction;
